<template>
    <div class="list__item guest__item">
        <div class="guest__content">
            <div class="guest__header">
                <h4 class="title-h4">
                    {{ $t("studio.dashboard.check_in.title") }}
                </h4>
                <div class="guest__info">
                    <img
                            src="@/assets/images/dashboard/info.svg"
                            alt="">
                    <div class="guest__text font-reg">
                        {{ $t("studio.dashboard.check_in.text") }}
                    </div>
                </div>
            </div>
            <form class="form" @submit.prevent="sendCodeHandler">
                <div class="form__row">
                    <div class="form__title font-semi">
                        {{ $t("form.pass_code") }}
                    </div>
                    <div class="form__field">
                        <simpleInput
                                v-model="code"
                                :v="$v.code"
                                @input="inputHandler"
                                :placeholder="$t('form.pass_code')"/>
                        <div class="form__field-error" v-if="codeIsError">
                            {{codeErrorText}}
                        </div>
                    </div>
                </div>
                <div class="form__action">
                    <button
                            type="submit"
                            class="form__button btn btn-w100 btn-gradient"
                            :disabled="buttonIsAvaible"
                    >
                        <span>{{ $t("form.check_pass_code") }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import SimpleInput from '@/elements/SimpleInput'
    import { numeric } from 'vuelidate/lib/validators'

    export default {
        components: {
            SimpleInput
        },
        data() {
            return {
                code: '',
                codeIsError: false,
                codeErrorText: ''
            }
        },
        validations() {
          return {
              code: {
                  numeric,
                  isEqual10: (val) => val.length === 10,
                  isError: (val) => val.length && !this.codeIsError
            }
          }
        },
        methods: {
            inputHandler() {
                if(this.codeIsError) this.codeIsError = !this.codeIsError
            },
            async sendCodeHandler() {
                this.$v.code.$touch();
                if (!this.$v.code.$invalid) {
                    try {
                        let response = await this.$store.dispatch('PASS_CODE_CHECK',{code: this.code})
                        if(response && response.status === 422) {
                            if(response.data.errors.code) {
                                this.codeIsError = true
                                this.codeErrorText = response.data.errors.code[0]
                            }
                        } else {
                            this.$router.push('/studios/members/check-in')
                        }
                    }catch(e) {
                        console.log(e.response, 'here now')
                    }
                }
            },
        },
        computed: {
            buttonIsAvaible() {
                if(this.code.length && !this.$v.code.$invalid) return false;
                else return true;
            }
        }
    }
</script>
<style lang="sass" scoped>
    .guest
        &__info
            display: flex
            align-items: center
            margin: 9px 0
        &__text
            margin-left: 12px
            color: $color--dark-lighten
            max-width: 257px
            width: 100%
            font-size: 12px
            line-height: 18px
            letter-spacing: 0.005em
            +md
                font-size: 10px
        &__content
            display: flex
            height: 100%
            flex-direction: column
        &__item
            position: relative
            +xs
                height: 100%!important
    .form
        flex: 1
        display: flex
        flex-direction: column
        align-items: stretch
        justify-content: space-between
        &__title
            font-size: 18px
            line-height: 21px
            margin-bottom: 12px
        &__button
            height: 40px
        &__field
            position: relative
            &-error
                position: absolute
                bottom: 0
                left: 0
                width: 100%
                +reg
                color: $color--red
                font-size: 10px

</style>
